import React, { useEffect, useContext } from "react";
import Page from "./Page";
import MaterialTable from "material-table";

import WarningInfo from "./notification/WarningInfo";
import AppContext from "./context/AppContext";
import ActionContext from "./context/ActionContext";
import {
	FETCH_EMPLOYERS,
	UPDATE_EMPLOYER,
	CREATE_EMPLOYER,
	DELETE_EMPLOYER
} from "./context/types";

export default function EmployersPage(props) {
	const { employers, loading, updating } = useContext(AppContext);
	const dispatch = useContext(ActionContext);
	useEffect(() => {
		document.title = "Available Employers";
		dispatch({ type: FETCH_EMPLOYERS });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<Page header="Employers" location={props.location.pathname}>
			{!loading && (
				<MaterialTable
					title="Available Employers"
					columns={[
						{
							title: "Name*",
							field: "name"
						},
						{
							title: "Approved*",
							field: "approved",
							type: "boolean"
						}
					]}
					data={employers}
					components={{
						Toolbar: props => {
							return (
								<WarningInfo
									toolbar={props}
									message="Be careful deleting rows as it may affect users information"
								/>
							);
						}
					}}
					editable={{
						onRowAdd: newData =>
							new Promise((resolve, reject) => {
								dispatch({
									type: CREATE_EMPLOYER,
									payload: newData
								});
								if (!updating) {
									resolve();
								}
							}),
						onRowUpdate: (newData, oldData) =>
							new Promise((resolve, reject) => {
								dispatch({
									type: UPDATE_EMPLOYER,
									payload: {
										name: oldData.name,
										data: newData
									}
								});
								if (!updating) {
									resolve();
								}
							}),
						onRowDelete: oldData =>
							new Promise((resolve, reject) => {
								dispatch({
									type: DELETE_EMPLOYER,
									payload: oldData
								});
								if (!updating) {
									resolve();
								}
							})
					}}
					options={{
						actionsColumnIndex: -1
					}}
				/>
			)}
		</Page>
	);
}
